// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { AppConstants, LMTimeStampDirective } from '@utils/index';
import { SohoTimePickerComponent } from 'ids-enterprise-ng';

enum LMTimeTypeDisplayEnum {
  PLAIN = 0,
  DISPLAY_AS_TEXT,
  DISPLAY_AS_TAG
}

@Component({
  selector:    'lm-time',
  standalone: false,
  templateUrl: './lm-time.component.html',
  styleUrls:   [ 'lm-time.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
  })
export class LMTimeComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {

  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  @HostBinding('attr.class') hostClass = 'field';

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  @ViewChild(SohoTimePickerComponent) time: SohoTimePickerComponent;

  // TODO: soho-timepicker.component should be modified to have an options object
  public timeFormat: string = undefined;
  public mode: SohoTimePickerMode = undefined;
  public minuteInterval: number = undefined;
  public secondInterval: number = undefined;

  public displayType: LMTimeTypeDisplayEnum;
  public layoutDisplayType;
  private passTimeStampValue = false;
  public filterSettings: Array<SohoFieldFilterOption>;

  constructor(protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
    this.layoutDisplayType = LMTimeTypeDisplayEnum;
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.setOptions();

    if (this.displayAsTag && !this.isCompoundFieldMember) {
      this.displayType = this.layoutDisplayType.DISPLAY_AS_TAG;

    } else if (this.displayAsText && !this.isCompoundFieldMember) {
      this.displayType = this.layoutDisplayType.DISPLAY_AS_TEXT;

    } else {
      this.subscribeToInlineError();
      this.displayType = this.layoutDisplayType.PLAIN;
    }

    this.filterSettings = (this.hasRangeFilterSettings()) ? this.getRangeFilterSettings(): this.numericFilterSettings;

    // This a workaround because the soho-datepicker control does not hold it's
    // isReadOnly value correctly on initialization. Can use the template with the
    // readOnly$ async pipe once this is fixed in the next controls update
    this.subscriptionArray.push(this.readOnly$.subscribe((disable: boolean) => {
      if (this.time) {
        this.time.readonly = disable;
      } else {
        // On init, need a tick for the ids component to exist
        setTimeout(() => {
          if (this.time) {
            this.time.readonly = disable;
          }
        });
      }
    }));

    this.subscribeToTimezoneField();

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public onNgModelChange(value) {
    if (this.passTimeStampValue) {
      this.transformOptions.timeStampDataValue = this.modelField.value;
    }

    this.modelField.toDataValue(value, this.transformOptions);
  }

  private subscribeToTimezoneField() {
    if (this.specField.type === AppConstants.TIMESTAMP && this.layoutObject.timeZoneIs) {
      this.transformOptions.timeZone = this.model.getField(this.layoutObject.timeZoneIs).value;
      this.subscriptionArray.push(this.model.timeZoneChangedEvent$
        .subscribe(({ bindId, timeZone, previousTimeZone }) => {
          if (bindId === this.layoutObject.timeZoneIs) {
            this.transformOptions.timeZone = timeZone;
          }
        }));
    }
  }

  // private methods
  private setOptions() {
    // TODO: soho-timepicker.component should be modified to have an options object
    this.mode = 'standard';

    // default format - full time
    this.timeFormat = Soho.Locale.calendar().dateFormat.timestamp;

    if (this.lmFieldServiceAdapter.lmFieldLayoutService.hasLimitToMinuteIncrements(this.field, this.specField)) {
      //this.timeFormat = Soho.Locale.calendar().timeFormat;
      this.minuteInterval = this.layoutObject.limitToMinuteIncrements;
    } else {
      this.minuteInterval = 1;
      this.secondInterval = 1;
    }

    if (this.timeStampDirective === LMTimeStampDirective.DISPLAY_HOURS_AND_MINUTES) {
      // supported for TimeStamp and Time types
      this.timeFormat = Soho.Locale.calendar().timeFormat;
      this.passTimeStampValue = (this.specField.type === AppConstants.TIMESTAMP);

    } else if (this.timeStampDirective === LMTimeStampDirective.DISPLAY_TIME) {
      // supported for TimeStamp type only
      // uses default format
      this.passTimeStampValue = (this.specField.type === AppConstants.TIMESTAMP);
    }
  }

  onTimeChange() {
    if (!this.hasFieldChanged) {
      // came back from the picker - user did not type in the input
      // lm-field-base has a change host listener that is
      // handling user input (typing in a value)
      this.onChange();
      this.handleOnFieldChanged();
    }
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }
}
